/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId, skipImage) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const productJsonEl = document.getElementById("ProductJson-" + formId);
  if (!productJsonEl) {
    console.error("Product JSON not found for form:", formId);
    return;
  }

  try {
    const product = JSON.parse(productJsonEl.textContent);
    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    const variant = product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

    if (variant) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      if (variant.price != null) {
        const currency = document.querySelector('meta[name="currency"]')?.content || "USD";
        const formattedPrice = formatMoney(variant.price, currency);
        const container = form.closest('[class*="upsell-product-container-"]');
        if (container) {
          container.querySelectorAll('.upsell-price, [class*="upsell-toggle-price-"], [class*="upsell-product-price-"]').forEach(function (el) {
            el.textContent = formattedPrice;
          });
        }
      }

      var img = skipImage ? null : form.querySelector("img");
      if (img) {
        var imgData = variant && variant.featured_image ? variant.featured_image : null;
        if (!imgData && product.featured_image) {
          var fi = product.featured_image;
          imgData = { src: typeof fi === "string" ? fi : fi.src, alt: "" };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, "https://").split("?")[0] + "?width=150";
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function () {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }
    }

    selects.forEach(function (currentSelect, idx) {
      Array.from(currentSelect.options).forEach(function (opt) {
        var test = selectedOptions.slice();
        test[idx] = opt.value;
        opt.disabled = !product.variants.some(function (v) {
          return test.every(function (val, i) {
            return v.options[i] === val;
          });
        });
      });
    });
  } catch (error) {
    console.error("Error handling variant change:", error);
  }
};

// Handle add to cart
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const cartAction = form.dataset.cartAction || "drawer";
  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");
  buttonElement.innerHTML = '<span class="button-spinner"></span>';

  try {
    if (cartAction === "redirect") {
      const response = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error("Failed to add to cart");
      const data = JSON.parse(await response.text());
      if (data.status) throw new Error(data.description || "Failed to add to cart");
      window.location = window.routes?.cart_url || "/cart";
      return;
    }

    const formData = new FormData(form);
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", window.location.pathname);

    const response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
      body: formData,
    });

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      throw new Error("Unable to add to cart. Please try again.");
    }
    if (data.status) throw new Error(data.description || "Error adding product to cart");

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
    }

    setTimeout(() => { upsellCarousel(); }, 100);

    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-success");
    buttonElement.innerHTML = "✓ Added!";

    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-success");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  } catch (error) {
    console.error("Error adding to cart:", error);
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-error");
    buttonElement.innerHTML = "✗ Error";
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-error");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};

// Handle toggle switch add/remove from cart
window.handleProductUpsellToggle = async function (toggleElement, formId, uniqueId) {
  if (toggleElement.dataset.processing === "true") return;
  toggleElement.dataset.processing = "true";

  const form = document.getElementById(formId);
  if (!form) {
    toggleElement.checked = !toggleElement.checked;
    toggleElement.dataset.processing = "false";
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    toggleElement.checked = !toggleElement.checked;
    toggleElement.dataset.processing = "false";
    return;
  }

  const toggleSwitch = document.querySelector(".upsell-toggle-switch-" + uniqueId) || toggleElement.parentElement;
  const isAdding = toggleElement.checked;
  const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
  const cartChangeUrl = window.routes?.cart_change_url || "/cart/change";

  if (toggleSwitch) toggleSwitch.classList.add("is-loading");

  try {
    if (isAdding) {
      const response = await fetch(cartAddUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error("Failed to add to cart");
    } else {
      const cart = await (await fetch("/cart.js")).json();
      const cartItem = cart.items.find((item) => item.variant_id == variantId);
      if (cartItem) {
        const response = await fetch(cartChangeUrl + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variantId.toString(), quantity: cartItem.quantity - 1 }),
        });
        if (!response.ok) throw new Error("Failed to remove from cart");
      }
    }

    if (toggleSwitch) toggleSwitch.classList.remove("is-loading");
    toggleElement.dataset.processing = "false";

    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    if (typeof window.refreshCartDrawer === "function") await window.refreshCartDrawer();
  } catch (error) {
    console.error("Error updating cart:", error);
    toggleElement.checked = !toggleElement.checked;
    if (toggleSwitch) toggleSwitch.classList.remove("is-loading");
    toggleElement.dataset.processing = "false";
  }
};

// Event delegation for toggle switches
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("upsell-toggle-input")) {
      const formId = e.target.dataset.formId;
      const uniqueId = e.target.dataset.uniqueId;
      if (formId && uniqueId) handleProductUpsellToggle(e.target, formId, uniqueId);
    }
  });
});

// Helper function to format money
function formatMoney(cents, currency = "USD") {
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format || "{{amount}}");
  }
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(cents / 100);
}

// Carousel/slider functionality
function upsellCarousel() {
  const slider = document.querySelector('.upsell_block_container');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.upsell-product-container'));
  if (!slides.length) return;

  const dotsAndArrows = document.querySelector('.dots-and-arrows');
  if (!dotsAndArrows) return;

  if (slides.length <= 1) {
    dotsAndArrows.style.display = 'none';
    return;
  }

  dotsAndArrows.style.display = 'flex';
  dotsAndArrows.style.alignItems = 'center';
  dotsAndArrows.style.justifyContent = 'center';
  dotsAndArrows.style.gap = '8px';
  dotsAndArrows.style.marginTop = '8px';

  const prevBtn = document.getElementById('slide-arrow-prev');
  const nextBtn = document.getElementById('slide-arrow-next');
  if (prevBtn) { prevBtn.style.display = 'flex'; prevBtn.style.visibility = 'visible'; }
  if (nextBtn) { nextBtn.style.display = 'flex'; nextBtn.style.visibility = 'visible'; }

  let currentIndex = 0;
  let isScrolling = false;

  function getDots() {
    return Array.from(dotsAndArrows.querySelectorAll('.slide_item'));
  }

  function updateDots(index) {
    getDots().forEach((dot, i) => dot.classList.toggle('active', i === index));
  }

  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    // Disable scroll listener temporarily to avoid feedback loop
    isScrolling = true;

    slider.scrollTo({
      left: slider.offsetWidth * currentIndex,
      behavior: 'smooth'
    });

    updateDots(currentIndex);

    // Re-enable scroll listener after animation completes
    setTimeout(() => { isScrolling = false; }, 500);
  }

  // Event delegation on dotsAndArrows for dots + arrows
  dotsAndArrows.onclick = function (e) {
    const dot = e.target.closest('.slide_item');
    if (dot) {
      const index = getDots().indexOf(dot);
      if (index !== -1) goToSlide(index);
      return;
    }
    if (e.target.closest('#slide-arrow-prev')) goToSlide(currentIndex - 1);
    if (e.target.closest('#slide-arrow-next')) goToSlide(currentIndex + 1);
  };

  // Touch/swipe — track finger movement directly
  let touchStartX = 0;
  let touchStartScrollLeft = 0;
  let isTouching = false;

  slider.ontouchstart = (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartScrollLeft = slider.scrollLeft;
    isTouching = true;
    // Disable CSS scroll-snap temporarily so we control scrolling
    slider.style.scrollSnapType = 'none';
  };

  slider.ontouchmove = (e) => {
    if (!isTouching) return;
    const diff = touchStartX - e.touches[0].clientX;
    slider.scrollLeft = touchStartScrollLeft + diff;
  };

  slider.ontouchend = (e) => {
    if (!isTouching) return;
    isTouching = false;

    const diff = touchStartX - e.changedTouches[0].clientX;
    const slideWidth = slider.offsetWidth;

    // Re-enable scroll-snap
    slider.style.scrollSnapType = 'x mandatory';

    if (Math.abs(diff) > slideWidth * 0.2) {
      goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
    } else {
      // Snap back to current slide
      goToSlide(currentIndex);
    }
  };

  // Sync dots on manual scroll (only when not programmatically scrolling)
  slider.onscroll = () => {
    if (isScrolling || isTouching) return;
    const slideWidth = slider.offsetWidth;
    if (!slideWidth) return;
    const index = Math.round(slider.scrollLeft / slideWidth);
    if (index !== currentIndex && index >= 0 && index < slides.length) {
      currentIndex = index;
      updateDots(currentIndex);
    }
  };
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', upsellCarousel);

// Re-initialize after cart drawer updates
document.addEventListener('cart:updated', upsellCarousel);